module.exports = __webpack_public_path__ + "media/images/custom_page/ab6ix_event2/ab6ix-event-ko-45ffe3d0e4d46065721eb28c70835a82.png";